/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ClassroomUtilizationRow
 */
export interface ClassroomUtilizationRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassroomUtilizationRow
     */
    classroomId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ClassroomUtilizationRow
     */
    classroomName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassroomUtilizationRow
     */
    classesCount: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the ClassroomUtilizationRow interface.
 */
export function instanceOfClassroomUtilizationRow(value: object): value is ClassroomUtilizationRow {
    if (!('classroomId' in value) || value['classroomId'] === undefined) return false;
    if (!('classroomName' in value) || value['classroomName'] === undefined) return false;
    if (!('classesCount' in value) || value['classesCount'] === undefined) return false;
    return true;
}

export function ClassroomUtilizationRowFromJSON(json: any): ClassroomUtilizationRow {
    return ClassroomUtilizationRowFromJSONTyped(json, false);
}

export function ClassroomUtilizationRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassroomUtilizationRow {
    if (json == null) {
        return json;
    }
    return {
        
        'classroomId': ApiUserTasksGetPageParameterFromJSON(json['classroomId']),
        'classroomName': json['classroomName'],
        'classesCount': ApiUserTasksGetPageParameterFromJSON(json['classesCount']),
    };
}

export function ClassroomUtilizationRowToJSON(json: any): ClassroomUtilizationRow {
    return ClassroomUtilizationRowToJSONTyped(json, false);
}

export function ClassroomUtilizationRowToJSONTyped(value?: ClassroomUtilizationRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classroomId': ApiUserTasksGetPageParameterToJSON(value['classroomId']),
        'classroomName': value['classroomName'],
        'classesCount': ApiUserTasksGetPageParameterToJSON(value['classesCount']),
    };
}

